export function DeleteFolder() {
  return (
    <svg viewBox="0 0 600 401" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_4357_121767)">
        <path
          d="M530.528 243.876L520 244.1L514.672 244.188C512.896 244.228 511.104 244.188 509.32 244.236H508.968V243.876L508.944 234.9V234.5H509.344L519.936 234.548C523.464 234.548 527 234.636 530.528 234.676H530.744V234.9C530.744 236.42 530.68 237.932 530.64 239.428L530.528 243.876ZM530.528 243.876L530.416 239.356C530.416 237.868 530.328 236.396 530.312 234.924L530.528 235.148C527 235.188 523.464 235.276 519.936 235.276L509.344 235.324L509.744 234.924L509.696 243.876L509.344 243.524C511.088 243.524 512.832 243.524 514.576 243.564L519.84 243.66L530.528 243.876Z"
          fill="#EBEBEB"
        />
        <path
          d="M518.712 255.164L508.208 255.388L502.88 255.476C501.104 255.476 499.312 255.476 497.528 255.524H497.168V255.164L497.128 246.213V245.812H497.528L508.12 245.868C511.648 245.868 515.176 245.956 518.712 245.996H518.928V246.213C518.928 247.732 518.856 249.244 518.824 250.74L518.712 255.164ZM518.712 255.164L518.6 250.644C518.6 249.156 518.504 247.685 518.488 246.213L518.712 246.436C515.176 246.476 511.648 246.564 508.12 246.564L497.528 246.613L497.928 246.213L497.88 255.164L497.528 254.812C499.272 254.812 501.008 254.812 502.76 254.852L508.024 254.948L518.712 255.164Z"
          fill="#EBEBEB"
        />
        <path
          d="M90.6563 243.876L80.1603 244.1L74.8323 244.188C73.0483 244.228 71.2563 244.188 69.4723 244.236H69.1203V243.876L69.0723 234.9V234.5H69.4723L80.0643 234.548C83.5923 234.548 87.1283 234.636 90.6563 234.676H90.8803V234.9C90.8803 236.42 90.8163 237.932 90.7763 239.428L90.6563 243.876ZM90.6563 243.876L90.5443 239.356C90.5043 237.868 90.4563 236.396 90.4403 234.924L90.6563 235.148C87.1283 235.188 83.5923 235.276 80.0643 235.276L69.4723 235.324L69.8723 234.924V243.876L69.5123 243.524C71.2563 243.524 73.0003 243.524 74.7523 243.564L80.0003 243.7L90.6563 243.876Z"
          fill="#EBEBEB"
        />
        <path
          d="M78.8406 255.164L68.3366 255.388L63.0086 255.476C61.2326 255.476 59.4406 255.476 57.6566 255.524H57.3046V255.164L57.2646 246.213V245.812H57.6646L68.2566 245.868C71.7846 245.868 75.3206 245.956 78.8486 245.996H79.0726V246.213C79.0726 247.732 79.0086 249.244 78.9686 250.74L78.8406 255.164ZM78.8406 255.164L78.7286 250.644C78.7286 249.156 78.6406 247.685 78.6246 246.213L78.8406 246.436C75.3126 246.476 71.7766 246.564 68.2486 246.564L57.6566 246.613L58.0566 246.213L58.0086 255.164L57.6566 254.812C59.4006 254.812 61.1446 254.812 62.8886 254.852L68.1526 254.948L78.8406 255.164Z"
          fill="#EBEBEB"
        />
        <path
          d="M542.345 255.164L531.849 255.388L526.521 255.476C524.737 255.476 522.945 255.476 521.161 255.524H520.801V255.164V246.213V245.812H521.201L531.793 245.868C535.321 245.868 538.857 245.956 542.385 245.996H542.609V246.213C542.609 247.732 542.545 249.244 542.505 250.74L542.345 255.164ZM542.345 255.164L542.233 250.644C542.233 249.156 542.145 247.685 542.129 246.213L542.345 246.436C538.817 246.476 535.281 246.564 531.753 246.564L521.161 246.613L521.561 246.213L521.521 255.164L521.161 254.812C522.905 254.812 524.649 254.812 526.401 254.852L531.665 254.948L542.345 255.164Z"
          fill="#EBEBEB"
        />
        <path
          d="M378.952 110.397L368.448 110.621L363.12 110.709C361.344 110.749 359.552 110.709 357.768 110.757H357.408V110.397L357.368 101.445V101.045H357.768L368.36 101.093C371.888 101.093 375.424 101.189 378.952 101.229H379.2V101.445C379.2 102.965 379.136 104.477 379.096 105.965L378.952 110.397ZM378.952 110.397L378.84 105.877C378.8 104.381 378.744 102.909 378.736 101.445L378.952 101.661C375.424 101.661 371.888 101.789 368.36 101.797L357.768 101.845L358.168 101.445L358.12 110.397L357.768 110.037C359.512 110.037 361.256 110.037 363 110.085L368.264 110.173L378.952 110.397Z"
          fill="#EBEBEB"
        />
        <path
          d="M367.137 121.684L356.633 121.908L351.305 121.996C349.529 121.996 347.737 121.996 345.953 122.044H345.601V121.684L345.561 112.732V112.332H345.969L356.561 112.38C360.089 112.38 363.617 112.476 367.153 112.516H367.369V112.732C367.369 114.252 367.297 115.764 367.265 117.252L367.137 121.684ZM367.137 121.684L367.025 117.164C367.025 115.668 366.929 114.196 366.913 112.732L367.137 112.948C363.601 112.988 360.073 113.076 356.545 113.084L345.953 113.132L346.353 112.732L346.305 121.684L345.953 121.324C347.697 121.324 349.433 121.324 351.185 121.372L356.449 121.46L367.137 121.684Z"
          fill="#EBEBEB"
        />
        <path
          d="M390.768 121.684L380.272 121.908L374.936 121.996C373.16 121.996 371.368 121.996 369.584 122.044H369.232V121.684V112.732V112.332H369.632L380.224 112.38C383.752 112.38 387.288 112.476 390.816 112.516H391.04V112.732C391.04 114.252 390.976 115.764 390.936 117.252L390.768 121.684ZM390.768 121.684L390.656 117.164C390.616 115.668 390.568 114.196 390.552 112.732L390.768 112.948C387.24 112.988 383.704 113.076 380.176 113.084L369.584 113.132L369.984 112.732L369.944 121.684L369.6 121.3C371.344 121.3 373.088 121.3 374.84 121.348L380.096 121.436L390.768 121.684Z"
          fill="#EBEBEB"
        />
        <path
          d="M119.736 196.589L109.232 196.813L103.904 196.901C102.128 196.901 100.336 196.901 98.5524 196.941H98.1924V196.581V187.629V187.229H98.5924L109.184 187.277C112.712 187.277 116.24 187.365 119.776 187.405H119.992V187.621C119.992 189.141 119.92 190.645 119.888 192.141L119.736 196.589ZM119.736 196.589L119.624 192.061C119.584 190.573 119.528 189.101 119.512 187.637L119.736 187.853C116.2 187.893 112.672 187.981 109.144 187.981L98.5524 188.037L98.9524 187.637L98.9044 196.589L98.5524 196.229C100.296 196.229 102.04 196.229 103.784 196.277L109.048 196.365L119.736 196.589Z"
          fill="#EBEBEB"
        />
        <path
          d="M217.072 278.307L206.568 278.531L201.24 278.619C199.464 278.659 197.672 278.619 195.888 278.667H195.528V278.307V269.355V268.955H195.928L206.52 269.011C210.048 269.011 213.584 269.099 217.112 269.139H217.328V269.355C217.328 270.875 217.264 272.387 217.224 273.883L217.072 278.307ZM217.072 278.307L216.96 273.787C216.92 272.299 216.872 270.819 216.856 269.355L217.072 269.579C213.544 269.579 210.008 269.699 206.48 269.707L195.888 269.755L196.288 269.355L196.24 278.307L195.888 277.955C197.632 277.955 199.376 277.955 201.12 277.995L206.4 278.099L217.072 278.307Z"
          fill="#EBEBEB"
        />
        <path
          d="M529.305 50.4047L518.801 50.6287L513.473 50.7167C511.697 50.7167 509.905 50.7167 508.121 50.7647H507.761V50.4047L507.721 41.4527V41.0527H508.121L518.713 41.1007C522.241 41.1007 525.769 41.1967 529.305 41.2367H529.521V41.4527C529.521 42.9727 529.457 44.4847 529.417 45.9727L529.305 50.4047ZM529.305 50.4047L529.193 45.8847C529.193 44.3887 529.097 42.9167 529.081 41.4527L529.305 41.6687C525.769 41.6687 522.241 41.7967 518.713 41.8047L508.121 41.8527L508.521 41.4527L508.473 50.4047L508.121 50.0447C509.865 50.0447 511.609 50.0447 513.353 50.0927L518.617 50.1807L529.305 50.4047Z"
          fill="#EBEBEB"
        />
        <path
          d="M541.12 61.6918L530.616 61.9158L525.288 62.0038C523.512 62.0438 521.72 62.0038 519.936 62.0518H519.584V61.6918L519.544 52.7398V52.3398H519.944L530.536 52.3878C534.064 52.3878 537.6 52.4838 541.128 52.5238H541.352V52.7398C541.352 54.2598 541.288 55.7718 541.248 57.2598L541.12 61.6918ZM541.12 61.6918L541.008 57.1718C541.008 55.6758 540.92 54.2038 540.904 52.7398L541.12 52.9558C537.592 52.9958 534.056 53.0838 530.528 53.0918L519.936 53.1398L520.336 52.7398L520.288 61.6918L519.936 61.3318C521.68 61.3318 523.424 61.3318 525.168 61.3798L530.432 61.4678L541.12 61.6918Z"
          fill="#EBEBEB"
        />
        <path
          d="M78.8399 50.4125L68.3359 50.6365L63.0079 50.7245C61.2319 50.7245 59.4399 50.7245 57.6559 50.7725H57.3039V50.4125L57.2559 41.4605V41.0605H57.6559L68.2479 41.1165C71.7759 41.1165 75.3119 41.2045 78.8399 41.2445H79.0639V41.4605C79.0639 42.9805 78.9999 44.4925 78.9599 45.9885L78.8399 50.4125ZM78.8399 50.4125L78.7279 45.8925C78.7279 44.4045 78.6399 42.9245 78.6239 41.4605L78.8399 41.6765C75.3119 41.7245 71.7759 41.8045 68.2479 41.8125L57.6559 41.8605L58.0559 41.4605L58.0079 50.4125L57.6559 50.1005C59.3999 50.1005 61.1439 50.1005 62.8879 50.1005L68.1519 50.1885L78.8399 50.4125Z"
          fill="#EBEBEB"
        />
        <path
          d="M75.3041 306.244H153.536L153.536 160.748H75.3041L75.3041 306.244Z"
          fill="#EBEBEB"
        />
        <path
          d="M71.5201 160.748H157.328V156.732H71.5201V160.748Z"
          fill="#DBDBDB"
        />
        <path
          d="M44.5287 160.748H71.5127V156.732H44.5287V160.748Z"
          fill="#EBEBEB"
        />
        <path
          d="M48.8007 306.244H75.3047L75.3047 160.748H48.8007L48.8007 306.244Z"
          fill="#DBDBDB"
        />
        <path
          d="M83.8246 254.34H145.017V219.844H83.8246V254.34Z"
          stroke="#C7C7C7"
          strokeWidth="0.25"
          strokeMiterlimit="10"
        />
        <path
          d="M111.04 236.756H122.992V229.884H111.04V236.756Z"
          fill="#C7C7C7"
        />
        <path
          d="M107.504 236.236H119.456V230.404H107.504V236.236Z"
          stroke="#C7C7C7"
          strokeWidth="0.25"
          strokeMiterlimit="10"
        />
        <path
          d="M83.8246 297.924H145.017V263.428H83.8246V297.924Z"
          stroke="#C7C7C7"
          strokeWidth="0.25"
          strokeMiterlimit="10"
        />
        <path
          d="M111.04 280.34H122.992V273.468H111.04V280.34Z"
          fill="#C7C7C7"
        />
        <path
          d="M107.504 279.82H119.456V273.988H107.504V279.82Z"
          stroke="#C7C7C7"
          strokeWidth="0.25"
          strokeMiterlimit="10"
        />
        <path
          d="M83.8246 210.756H145.017V176.26H83.8246V210.756Z"
          fill="#A6A6A6"
        />
        <path
          d="M136.368 167.428H89.7842V201.196H136.368V167.428Z"
          fill="#C7C7C7"
        />
        <path
          d="M119.904 163.924H136.368V167.428H118.96L119.904 163.924Z"
          fill="#C7C7C7"
        />
        <path
          d="M89.9043 201.189H136.488L140.08 170.229H93.4963L89.9043 201.189Z"
          fill="#A6A6A6"
        />
        <path
          d="M123.992 167.02H140.448L140.08 170.228H122.672L123.992 167.02Z"
          fill="#A6A6A6"
        />
        <path
          d="M113.296 210.756H174.488V176.26H113.296V210.756Z"
          fill="#EBEBEB"
          stroke="#C7C7C7"
          strokeWidth="0.25"
          strokeMiterlimit="10"
        />
        <path
          d="M140.512 193.172H152.464V186.3H140.512V193.172Z"
          fill="#C7C7C7"
        />
        <path
          d="M136.977 192.652H148.929V186.82H136.977V192.652Z"
          stroke="#C7C7C7"
          strokeWidth="0.25"
          strokeMiterlimit="10"
        />
        <path
          d="M83.8243 210.756H113.152V181.428H83.8243V210.756Z"
          fill="#DBDBDB"
        />
        <path d="M164.576 37.02V0.5" stroke="#C7C7C7" strokeMiterlimit="10" />
        <path
          d="M187.145 58.7631L185.329 62.7551H143.825L142.009 58.7631L159.681 46.5391H169.473L187.145 58.7631Z"
          fill="#EBEBEB"
        />
        <path
          d="M170.696 34.7559L169.472 46.5399H159.68L158.456 34.7559H170.696Z"
          fill="#DBDBDB"
        />
        <path
          d="M187.137 58.7715L185.321 62.7555H143.817L142.009 58.7715H187.137Z"
          fill="#DBDBDB"
        />
        <path d="M254.856 37.02V0.5" stroke="#C7C7C7" strokeMiterlimit="10" />
        <path
          d="M277.424 58.7631L275.608 62.7551H234.104L232.296 58.7631L249.968 46.5391H259.752L277.424 58.7631Z"
          fill="#EBEBEB"
        />
        <path
          d="M260.984 34.7559L259.752 46.5399H249.968L248.736 34.7559H260.984Z"
          fill="#DBDBDB"
        />
        <path
          d="M277.424 58.7715L275.608 62.7555H234.104L232.296 58.7715H277.424Z"
          fill="#DBDBDB"
        />
        <path d="M345.145 37.02V0.5" stroke="#C7C7C7" strokeMiterlimit="10" />
        <path
          d="M367.704 58.7631L365.896 62.7551H324.392L322.576 58.7631L340.248 46.5391H350.04L367.704 58.7631Z"
          fill="#EBEBEB"
        />
        <path
          d="M351.264 34.7559L350.04 46.5399H340.248L339.024 34.7559H351.264Z"
          fill="#DBDBDB"
        />
        <path
          d="M367.704 58.7715L365.888 62.7555H324.384L322.576 58.7715H367.704Z"
          fill="#DBDBDB"
        />
        <path d="M435.425 37.02V0.5" stroke="#C7C7C7" strokeMiterlimit="10" />
        <path
          d="M457.992 58.7631L456.176 62.7551H414.672L412.864 58.7631L430.528 46.5391H440.32L457.992 58.7631Z"
          fill="#EBEBEB"
        />
        <path
          d="M441.545 34.7559L440.321 46.5399H430.529L429.305 34.7559H441.545Z"
          fill="#DBDBDB"
        />
        <path
          d="M457.992 58.7715L456.176 62.7555H414.672L412.864 58.7715H457.992Z"
          fill="#DBDBDB"
        />
        <path
          d="M43.4482 306.244L107.584 306.052L171.72 305.98L300 305.844L428.28 305.98L492.416 306.052L556.552 306.244L492.416 306.444L428.28 306.508L300 306.644L171.72 306.508L107.584 306.436L43.4482 306.244Z"
          fill="#263238"
        />
        <path
          d="M300 372.148C430.07 372.148 535.512 364.171 535.512 354.332C535.512 344.492 430.07 336.516 300 336.516C169.931 336.516 64.4883 344.492 64.4883 354.332C64.4883 364.171 169.931 372.148 300 372.148Z"
          fill="#EBEBEB"
        />
        <path d="M396.08 212.277H174V355.861H396.08V212.277Z" fill="#E14277" />
        <path
          d="M326.096 197.404H396.08V212.276H322.072L326.096 197.404Z"
          fill="#E14277"
        />
        <g opacity="0.1">
          <path d="M396.08 212.275H174V355.859H396.08V212.275Z" fill="white" />
          <path
            d="M326.096 197.404H396.08V212.276H322.072L326.096 197.404Z"
            fill="#E14277"
          />
        </g>
        <path
          d="M208.816 117.861C208.277 115.54 208.277 113.126 208.816 110.805C209.103 111.958 209.237 113.144 209.216 114.333C209.233 115.521 209.099 116.707 208.816 117.861Z"
          fill="#263238"
        />
        <path
          d="M216 119.932C216.331 118.791 216.807 117.697 217.416 116.676C217.991 115.637 218.698 114.677 219.52 113.82C219.192 114.963 218.716 116.058 218.104 117.076C217.528 118.115 216.821 119.075 216 119.932Z"
          fill="#263238"
        />
        <path
          d="M221.192 125.301C222.048 124.479 223.005 123.769 224.04 123.189C225.056 122.588 226.141 122.116 227.272 121.781C225.539 123.4 223.46 124.604 221.192 125.301Z"
          fill="#263238"
        />
        <path
          d="M222.992 132.572C224.144 132.293 225.327 132.158 226.512 132.172C227.701 132.151 228.887 132.285 230.04 132.572C228.888 132.851 227.706 132.985 226.52 132.972C225.332 132.989 224.146 132.855 222.992 132.572Z"
          fill="#263238"
        />
        <path
          d="M220.92 139.766C222.061 140.094 223.155 140.567 224.176 141.174C225.213 141.755 226.172 142.465 227.032 143.286C224.756 142.587 222.666 141.384 220.92 139.766Z"
          fill="#263238"
        />
        <path
          d="M215.536 144.949C216.356 145.809 217.066 146.769 217.648 147.805C218.257 148.823 218.733 149.915 219.064 151.053C217.438 149.314 216.231 147.226 215.536 144.949Z"
          fill="#263238"
        />
        <path
          d="M208.272 146.748C208.811 149.069 208.811 151.483 208.272 153.804C207.985 152.651 207.851 151.464 207.872 150.276C207.855 149.088 207.989 147.902 208.272 146.748Z"
          fill="#263238"
        />
        <path
          d="M201.088 144.676C200.757 145.817 200.281 146.911 199.672 147.932C199.099 148.974 198.391 149.937 197.568 150.796C197.9 149.652 198.375 148.555 198.984 147.532C199.566 146.497 200.272 145.538 201.088 144.676Z"
          fill="#263238"
        />
        <path
          d="M195.904 139.293C195.044 140.114 194.085 140.823 193.048 141.405C192.03 142.02 190.935 142.499 189.792 142.829C191.538 141.206 193.627 139.997 195.904 139.293Z"
          fill="#263238"
        />
        <path
          d="M194.104 132.036C192.949 132.315 191.764 132.449 190.576 132.436C189.388 132.456 188.202 132.324 187.048 132.044C188.202 131.758 189.387 131.621 190.576 131.636C191.764 131.623 192.949 131.757 194.104 132.036Z"
          fill="#263238"
        />
        <path
          d="M196.168 124.852C195.027 124.519 193.933 124.043 192.912 123.436C191.877 122.855 190.918 122.148 190.056 121.332C191.197 121.661 192.291 122.134 193.312 122.74C194.351 123.317 195.311 124.027 196.168 124.852Z"
          fill="#263238"
        />
        <path
          d="M201.56 119.702C200.738 118.846 200.028 117.889 199.448 116.854C198.833 115.835 198.355 114.741 198.024 113.598C198.849 114.454 199.559 115.414 200.136 116.454C200.745 117.473 201.223 118.564 201.56 119.702Z"
          fill="#263238"
        />
        <path
          d="M380.456 142.244H236.016V327.652H380.456V142.244Z"
          fill="#EBEBEB"
        />
        <path
          d="M380.448 327.654L236.016 327.91H235.76V327.654L235.624 142.246V141.854H236.016L380.448 141.942H380.752V142.246L380.448 327.654ZM380.448 327.654L380.152 142.246L380.448 142.542L236.016 142.638L236.408 142.246L236.264 327.654L236.016 327.406L380.448 327.654Z"
          fill="#DBDBDB"
        />
        <path
          d="M251.816 181.869L308.232 181.725L364.648 181.869L308.232 182.013L251.816 181.869Z"
          fill="#C7C7C7"
        />
        <path
          d="M251.816 186.468L308.232 186.324L364.648 186.468L308.232 186.612L251.816 186.468Z"
          fill="#C7C7C7"
        />
        <path
          d="M251.816 191.078L308.232 190.934L364.648 191.078L308.232 191.214L251.816 191.078Z"
          fill="#C7C7C7"
        />
        <path
          d="M251.816 195.677L308.232 195.533L364.648 195.677L308.232 195.821L251.816 195.677Z"
          fill="#C7C7C7"
        />
        <path
          d="M251.816 200.277L308.232 200.133L364.648 200.277L308.232 200.421L251.816 200.277Z"
          fill="#C7C7C7"
        />
        <path
          d="M251.816 204.876L308.232 204.732L364.648 204.876L308.232 205.02L251.816 204.876Z"
          fill="#C7C7C7"
        />
        <path
          d="M251.816 209.476L308.232 209.332L364.648 209.476L308.232 209.62L251.816 209.476Z"
          fill="#C7C7C7"
        />
        <path
          d="M251.816 214.077L308.232 213.941L364.648 214.077L308.232 214.221L251.816 214.077Z"
          fill="#C7C7C7"
        />
        <path
          d="M251.816 218.685L308.232 218.541L364.648 218.685L308.232 218.821L251.816 218.685Z"
          fill="#C7C7C7"
        />
        <path
          d="M251.816 223.285L308.232 223.141L364.648 223.285L308.232 223.421L251.816 223.285Z"
          fill="#C7C7C7"
        />
        <path
          d="M251.816 227.884L308.232 227.74L364.648 227.884L308.232 228.028L251.816 227.884Z"
          fill="#C7C7C7"
        />
        <path
          d="M251.816 232.484L308.232 232.34L364.648 232.484L308.232 232.628L251.816 232.484Z"
          fill="#C7C7C7"
        />
        <path
          d="M251.816 237.085L308.232 236.941L364.648 237.085L308.232 237.229L251.816 237.085Z"
          fill="#C7C7C7"
        />
        <path
          d="M251.816 241.685L308.232 241.549L364.648 241.685L308.232 241.829L251.816 241.685Z"
          fill="#C7C7C7"
        />
        <path
          d="M251.816 246.284L308.232 246.148L364.648 246.284L308.232 246.428L251.816 246.284Z"
          fill="#C7C7C7"
        />
        <path
          d="M272.304 232.34H263.744V251.652H272.304V232.34Z"
          fill="#E14277"
        />
        <path
          d="M288.176 222.045H279.616V251.653H288.176V222.045Z"
          fill="#E14277"
        />
        <path
          d="M304.048 210.508H295.488V251.652H304.048V210.508Z"
          fill="#E14277"
        />
        <path
          d="M319.928 205.557H311.368V251.653H319.928V205.557Z"
          fill="#E14277"
        />
        <path d="M335.8 196.732H327.24V251.652H335.8V196.732Z" fill="#E14277" />
        <path
          d="M351.672 188.012H343.112V251.652H351.672V188.012Z"
          fill="#E14277"
        />
        <path
          d="M254.872 178.645L255.096 196.893L255.248 215.149C255.352 227.317 255.384 239.485 255.408 251.653L254.872 251.125H282.32L309.76 251.189L337.208 251.365L364.648 251.677L337.208 251.989L309.76 252.165L282.32 252.229H254.872H254.344V251.701C254.344 239.533 254.392 227.365 254.496 215.197L254.656 196.941L254.872 178.645Z"
          fill="#C7C7C7"
        />
        <path
          d="M272.304 255.508H263.744V256.284H272.304V255.508Z"
          fill="#C7C7C7"
        />
        <path
          d="M288.176 255.508H279.616V256.284H288.176V255.508Z"
          fill="#C7C7C7"
        />
        <path
          d="M304.048 255.508H295.488V256.284H304.048V255.508Z"
          fill="#C7C7C7"
        />
        <path
          d="M319.928 255.508H311.368V256.284H319.928V255.508Z"
          fill="#C7C7C7"
        />
        <path d="M335.8 255.508H327.24V256.284H335.8V255.508Z" fill="#C7C7C7" />
        <path
          d="M351.672 255.508H343.112V256.284H351.672V255.508Z"
          fill="#C7C7C7"
        />
        <path
          d="M264.712 234.78C268.893 234.715 273.066 234.397 277.208 233.828C281.347 233.299 285.457 232.559 289.52 231.612C297.655 229.782 305.546 227.003 313.032 223.332C320.536 219.716 327.458 215 333.568 209.34L334.728 208.292L335.824 207.18L338.008 204.948C339.352 203.348 340.8 201.86 342.008 200.148C344.597 196.858 346.939 193.382 349.016 189.748H349.088C345.307 197.278 340.279 204.113 334.216 209.964C331.193 212.906 327.922 215.582 324.44 217.964C320.978 220.369 317.338 222.509 313.552 224.364C298.323 231.658 281.576 235.223 264.696 234.764L264.712 234.78Z"
          fill="#263238"
        />
        <path
          d="M351.456 195.749L350.272 196.045L348.816 190.205L343.096 192.085L342.72 190.925L349.68 188.637L351.456 195.749Z"
          fill="#263238"
        />
        <path
          d="M249.4 285.125H367.064V280.365H249.4V285.125Z"
          fill="#DBDBDB"
        />
        <path
          d="M249.408 297.141H315.648V292.381H249.408V297.141Z"
          fill="#DBDBDB"
        />
        <path
          d="M275.112 167.492H341.352V162.732H275.112V167.492Z"
          fill="#DBDBDB"
        />
        <path
          d="M352.984 317.732L208.544 317.66L208.64 132.252L315.88 132.308L353.056 167.652L352.984 317.732Z"
          fill="#EBEBEB"
        />
        <path
          opacity="0.6"
          d="M352.984 317.732L208.544 317.66L208.64 132.252L315.88 132.308L353.056 167.652L352.984 317.732Z"
          fill="#A6A6A6"
        />
        <path
          d="M315.88 132.309L353.056 167.653L315.864 167.637L315.88 132.309Z"
          fill="#EBEBEB"
        />
        <path
          opacity="0.4"
          d="M315.88 132.309L353.056 167.653L315.864 167.637L315.88 132.309Z"
          fill="#A6A6A6"
        />
        <path d="M222.632 168.34H302.936V163.58H222.632V168.34Z" fill="white" />
        <path
          d="M222.716 180.14L303.02 180.182L303.022 175.422L222.718 175.38L222.716 180.14Z"
          fill="white"
        />
        <path
          d="M222.698 192.157L303.002 192.199L303.004 187.439L222.7 187.397L222.698 192.157Z"
          fill="white"
        />
        <path
          d="M222.689 204.169L340.353 204.23L340.355 199.47L222.691 199.409L222.689 204.169Z"
          fill="white"
        />
        <path
          d="M222.687 216.192L340.351 216.254L340.353 211.494L222.689 211.432L222.687 216.192Z"
          fill="white"
        />
        <path
          d="M222.685 228.208L340.349 228.27L340.351 223.51L222.687 223.448L222.685 228.208Z"
          fill="white"
        />
        <path
          d="M222.675 240.226L340.339 240.287L340.341 235.527L222.677 235.465L222.675 240.226Z"
          fill="white"
        />
        <path
          d="M222.665 252.241L340.329 252.303L340.332 247.543L222.668 247.481L222.665 252.241Z"
          fill="white"
        />
        <path
          d="M222.664 264.265L340.328 264.326L340.331 259.566L222.667 259.505L222.664 264.265Z"
          fill="white"
        />
        <path
          d="M222.662 276.28L340.326 276.342L340.329 271.582L222.665 271.52L222.662 276.28Z"
          fill="white"
        />
        <path
          d="M222.652 288.288L340.316 288.35L340.319 283.59L222.655 283.528L222.652 288.288Z"
          fill="white"
        />
        <path
          d="M222.643 300.306L340.307 300.367L340.309 295.607L222.645 295.546L222.643 300.306Z"
          fill="white"
        />
        <path
          d="M174.52 355.861H396.6L411.88 224.189H189.8L174.52 355.861Z"
          fill="#E14277"
        />
        <path
          d="M343.472 210.549H413.464L411.88 224.189H337.872L343.472 210.549Z"
          fill="#E14277"
        />
        <path
          d="M408.456 308.912C423.067 308.912 434.912 297.067 434.912 282.456C434.912 267.845 423.067 256 408.456 256C393.845 256 382 267.845 382 282.456C382 297.067 393.845 308.912 408.456 308.912Z"
          fill="#F4BBCE"
        />
        <path
          d="M424.801 285.176V279.744H392.121V285.176H424.801Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_4357_121767">
          <rect
            width="600"
            height="400"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
